var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28.223 43.252",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("g", {
    color: props.color,
    fill: "#293846"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.006 10.918a10.918 10.918 0 01-10.918 10.918A10.918 10.918 0 013.17 10.918 10.918 10.918 0 0114.088 0a10.918 10.918 0 0110.918 10.918zM14.078 22.617A14.11 14.11 0 00.02 36.728v6.522h28.223v-6.522a14.11 14.11 0 00-14.11-14.11 14.11 14.11 0 00-.054 0z"
  }))));
}

export default SvgFace;